var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFriendRequest({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SvgjsSvg1001",
    width: 288,
    height: 288,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs1002"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1008",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 288,
    height: 288,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.1 0 0 -.1 0 200)",
    fill: "#6666ff",
    className: "color000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1348 1601 c-56 -5 -72 -11 -105 -39 -21 -18 -53 -42 -70 -53 l-33-21 0 -110 c0 -101 -2 -110 -20 -115 -39 -10 -22 -118 24 -158 34 -29 56 -96 56 -170 0 -58 -2 -64 -22 -67 -14 -2 -24 -12 -28 -28 -6 -26 -24 -35 -94 -45 l-39 -6 36 -26 c86 -61 141 -187 159 -364 l12 -109 334 0 334 0 -6 87 c-20 260 -51 316 -221 399 -65 32 -92 51 -95 67 -4 16 -14 23 -38 25 l-32 3 0 68 c0 72 24 145 60 181 24 24 36 104 21 133 -7 13 -10 56 -9 107 3 76 0 91 -25 143 -21 43 -39 63 -71 82 -24 14 -47 24 -52 23 -5 0 -39 -4 -76 -7z",
    fill: "#6666ff",
    className: "color000 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556 1562 c-46 -12 -70 -25 -107 -61 -77 -75 -98 -170 -86 -401 l4 -95 37 -10 c21 -6 38 -15 39 -20 1 -6 14 -10 30 -10 32 0 36 -24 12 -83 -24 -55 -51 -79 -126 -107 -77 -30 -129 -68 -171 -124 -30 -41 -59 -161 -72 -293 l-7 -68 516 0 515 0 0 53 c0 133 -44 291 -94 340 -18 18 -77 54 -132 80 -54 27 -106 52 -114 56 -23 12 -50 72 -50 114 0 35 2 37 33 37 21 0 36 7 44 19 6 10 26 21 43 25 28 5 31 8 20 21 -9 11 -11 45 -6 133 13 207 -34 345 -136 398 -34 18 -115 16 -192 -4z",
    fill: "#6666ff",
    className: "color000 svgShape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriendRequest);
export default __webpack_public_path__ + "static/media/friendRequest.f4f22de821ae19d1e2811f395d2a58ea.svg";
export { ForwardRef as ReactComponent };